module.exports = new __parcel__URL__("connected_earth_energy.1dfcf61c.png").toString();